import type { PublicChecklistsQuery } from './queryParams';

/**
 * Query keys for the public checklist library.
 *
 * Keyed on the wire parameters rather than the app's filter state, so two callers asking the same
 * question share a cache entry however they spelled it, and so a follow or a copy can invalidate
 * exactly one list — `publicChecklistKeys.lists()` — without touching the detail pages.
 */
export const publicChecklistKeys = {
  all: () => ['publicChecklists'] as const,
  lists: () => [...publicChecklistKeys.all(), 'list'] as const,
  list: (query: PublicChecklistsQuery) => [...publicChecklistKeys.lists(), query] as const,
  infiniteLists: () => [...publicChecklistKeys.all(), 'infinite'] as const,
  infiniteList: (query: PublicChecklistsQuery) => [...publicChecklistKeys.infiniteLists(), query] as const,
  featuredLists: () => [...publicChecklistKeys.all(), 'featured'] as const,
  featuredList: (query: PublicChecklistsQuery) => [...publicChecklistKeys.featuredLists(), query] as const,
  details: () => [...publicChecklistKeys.all(), 'detail'] as const,
  detail: (uuid: string) => [...publicChecklistKeys.details(), uuid] as const,
} as const;
